import { Language } from '@app-types';
import locales from '@locales';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import { persistor, store } from '@store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import defaultTheme from '@themes';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { SnackbarProvider } from 'notistack';
import { withIFrameAccess } from '@hoc';
import { useAutoLogOut, useRouter } from './hooks';

import './global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App: React.FC = () => {
  const router = useRouter();

  useAutoLogOut();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={defaultTheme}>
        <SnackbarProvider>
          <IntlProvider messages={locales[Language.De]} locale={Language.De} defaultLocale={Language.De}>
            <RouterProvider router={router} />
            <GlobalStyles styles={{ body: { margin: 0 } }} />
          </IntlProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default withIFrameAccess(() => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
));
